export default {"src":"/_next/static/media/tiktok.fd9955d2.ico","height":266,"width":278,"blurWidth":0,"blurHeight":0};